module.exports = __webpack_public_path__ + "assets/913dea3dfc4a12172607ecd44ea145cb.png";